import { Model } from "@/models/Model";
export class ModelVuexDB extends Model {
    hasChanges() {
        return true;
    }
}
